/* Alpine Outlets local pages: live open/closed status, today's row in the hours table, and the live Google rating.
   Schedules come from <script type="application/json" data-ao-schedule="key"> written by the sections. */
(function () {
  if (window.aoLocalReady) return;
  window.aoLocalReady = true;

  var DAY_KEYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var TIME = /^([01]?\d|2[0-3]):([0-5]\d)$/;

  function toMinutes(hm) {
    var m = TIME.exec(hm);
    return m ? parseInt(m[1], 10) * 60 + parseInt(m[2], 10) : null;
  }

  function label(hm) {
    var total = toMinutes(hm);
    var h = Math.floor(total / 60);
    var mm = total % 60;
    var suffix = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    return h + (mm ? ':' + (mm < 10 ? '0' : '') + mm : '') + ' ' + suffix;
  }

  function readSchedules() {
    var out = {};
    document.querySelectorAll('script[data-ao-schedule]').forEach(function (el) {
      var key = el.getAttribute('data-ao-schedule');
      if (out[key]) return;
      try {
        var data = JSON.parse(el.textContent);
        var days = (data.days || []).slice(0, 7).map(function (d) {
          if (!d || d.length !== 2) return null;
          var a = toMinutes(d[0]);
          var b = toMinutes(d[1]);
          return a === null || b === null || b <= a ? null : d;
        });
        var closed = {};
        (data.closed || []).forEach(function (c) { if (c && /^\d{4}-\d{2}-\d{2}$/.test(c[0])) closed[c[0]] = String(c[1] || ''); });
        if (days.length === 7) out[key] = { tz: data.tz || 'America/Denver', days: days, closed: closed };
      } catch (e) { /* A malformed schedule keeps the fallback text. */ }
    });
    return out;
  }

  function now(tz) {
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    var get = function (type) {
      for (var i = 0; i < parts.length; i++) if (parts[i].type === type) return parts[i].value;
      return '';
    };
    return { day: DAY_KEYS.indexOf(get('weekday')), minutes: (parseInt(get('hour'), 10) % 24) * 60 + parseInt(get('minute'), 10) };
  }

  // The store's calendar date, offset days from today, as YYYY-MM-DD.
  function storeDate(tz, offset) {
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date(Date.now() + offset * 86400000));
    var get = function (type) {
      for (var i = 0; i < parts.length; i++) if (parts[i].type === type) return parts[i].value;
      return '';
    };
    return get('year') + '-' + get('month') + '-' + get('day');
  }

  function status(schedule) {
    var t = now(schedule.tz);
    if (t.day < 0 || isNaN(t.minutes)) return null;
    var closure = schedule.closed[storeDate(schedule.tz, 0)];
    var closedToday = closure !== undefined;
    var today = closedToday ? null : schedule.days[t.day];
    if (today && t.minutes >= toMinutes(today[0]) && t.minutes < toMinutes(today[1])) {
      return { state: 'open', text: 'Open now until ' + label(today[1]), day: t.day };
    }
    // Generic reasons like "Scheduled store closure" read better as plain "Closed today".
    var lead = closedToday ? 'Closed today' + (closure && !/closure/i.test(closure) ? ' for ' + closure : '') : 'Closed now';
    for (var i = 0; i < 15; i++) {
      var d = (t.day + i) % 7;
      var hours = schedule.days[d];
      if (!hours || schedule.closed[storeDate(schedule.tz, i)] !== undefined) continue;
      if (i === 0 && t.minutes < toMinutes(hours[0])) return { state: 'closed', text: lead + ', opens today at ' + label(hours[0]), day: t.day };
      if (i > 0) return { state: 'closed', text: lead + ', opens ' + (i === 1 ? 'tomorrow' : DAY_NAMES[d]) + ' at ' + label(hours[0]), day: t.day, closedToday: closedToday };
    }
    return null;
  }

  function apply() {
    var schedules = readSchedules();
    Object.keys(schedules).forEach(function (key) {
      var result = status(schedules[key]);
      if (!result) return;
      document.querySelectorAll('[data-ao-status-for="' + key + '"]').forEach(function (el) {
        el.setAttribute('data-state', result.state);
        var text = el.querySelector('[data-ao-status-text]');
        if (text) text.textContent = result.text;
      });
      document.querySelectorAll('[data-ao-hours="' + key + '"] [data-day]').forEach(function (row) {
        var isToday = parseInt(row.getAttribute('data-day'), 10) === result.day;
        row.classList.toggle('is-today', isToday);
        var cell = row.querySelector('td');
        if (isToday && result.closedToday && cell) {
          row.classList.add('is-closed');
          cell.textContent = 'Closed today';
        }
      });
    });
  }

  /* Live Google rating and review count, from the same feed the Reputon reviews app loads on the page.
     Each reviews panel picks its store by address; if the feed can't load, the hand-set rating and text stay. */
  var REVIEWS_FEED = 'https://grw.reputon.com/app/storefront/widget?lang=en&shop=';
  var reviewsRequest = null;

  function fillRating(panel, business) {
    var rating = business.rating.toFixed(1);
    var count = Number(business.reviewsNumber).toLocaleString('en-US');
    var number = panel.querySelector('[data-ao-rating]');
    if (number) number.textContent = rating;
    var text = panel.querySelector('[data-ao-rating-text]');
    var template = panel.getAttribute('data-ao-live-text');
    if (!text || !template) return;
    var p = document.createElement('p');
    template.split(/(\{rating\}|\{count\})/).forEach(function (part) {
      if (part === '{count}') {
        var strong = document.createElement('strong');
        strong.textContent = count;
        p.appendChild(strong);
      } else if (part) {
        p.appendChild(document.createTextNode(part === '{rating}' ? rating : part));
      }
    });
    while (text.firstChild) text.removeChild(text.firstChild);
    text.appendChild(p);
  }

  function liveRatings() {
    var panels = document.querySelectorAll('[data-ao-live-rating]');
    if (!panels.length || !window.fetch) return;
    reviewsRequest = reviewsRequest || fetch(REVIEWS_FEED + encodeURIComponent(panels[0].getAttribute('data-ao-live-rating')))
      .then(function (response) { return response.ok ? response.json() : null; });
    reviewsRequest.then(function (data) {
      var businesses = (data && data.business) || [];
      panels.forEach(function (panel) {
        var match = (panel.getAttribute('data-ao-live-match') || '').toLowerCase();
        if (!match) return;
        for (var i = 0; i < businesses.length; i++) {
          var business = businesses[i];
          if (String(business.address || '').toLowerCase().indexOf(match) === -1) continue;
          if (typeof business.rating === 'number' && business.reviewsNumber > 0) fillRating(panel, business);
          return;
        }
      });
    }).catch(function () { /* Keep the hand-set rating. */ });
  }

  function init() {
    apply();
    liveRatings();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
